import React, { useEffect, useState, useRef } from "react"
import { fabric } from "fabric";
import Select from 'react-select'
import { AvForm, AvField } from 'availity-reactstrap-validation';
import {
    Row,
    Col,
    Container,
    Card,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { v4 as uuidv4 } from 'uuid';

const shapes = [
    { value: 'Circle', label: 'Circle' },
    { value: 'Rect', label: 'Rect' },
    { value: 'node', label: 'node' }
]
const CanvasFabric = ({ activeCanvas, updateModeData }) => {
    const [activeCanvasData, setActiveCanvasData] = useState({
        id: "",
        path: "",
        shapes: []
    })
    const myStateRef = useRef(activeCanvasData)
    const [selectedShape, setSelectedShape] = useState({})
    const [canvas, setCanvas] = useState('');

    const renderSavedCanvasData = async (activeCanvas) => {


        if (canvas !== "") {
            await canvas.clear()
            await canvas.renderAll();
            setTimeout(() => {
                setActiveCanvasData(activeCanvas)
                myStateRef.current = activeCanvas
                new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
                    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                        scaleX: canvas.width / img.width,
                        scaleY: canvas.height / img.height
                    });
                })
                var deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
        var img = document.createElement('img');
        img.src = deleteIcon;
        fabric.Object.prototype.transparentCorners = false;
        fabric.Object.prototype.cornerColor = 'blue';
        fabric.Object.prototype.cornerStyle = 'circle';
         fabric.Object.prototype.controls.deleteControl = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetY: 16,
            cursorStyle: 'pointer',
            mouseUpHandler: deleteObject,
            render: renderIcon,
            cornerSize: 24
          });
        function deleteObject(eventData, transform) {
            var target = transform.target;
            var canvas = target.canvas;
            canvas.remove(target);
             const updatedShapesData= myStateRef.shapes.filter(item=>item.id !==target.id)
            setActiveCanvasData({
                ...activeCanvasData,
                shapes:updatedShapesData
            })
            canvas.requestRenderAll();
        }

        function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(img, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
                activeCanvas ?.shapes ?.forEach((shape, index) => {
                    if (shape.type === "Circle") {
                        var circle = new fabric.Circle(shape);
                        canvas.add(circle);
                    } else if (shape.type === "Rect") {
                        var rect = new fabric.Rect(shape);
                        canvas.add(rect);
                    } else {
                        var node = new fabric.Circle({
                            radius: 20,
                            fill: 'rgba(0,0,0,0)',
                            left: 0,
                            stroke: "red",
                            top: 30,
                            strokeWidth: 4,
                        });
                        var nodeChild = new fabric.Circle({
                            radius: 10,
                            fill: 'rgba(0,0,0,0)',
                            left: 12,
                            fill: "red",
                            top: 42,
                        });
                        var group = new fabric.Group([node, nodeChild], shape)
                        canvas.add(group);
                    }
                })
           }, 500);

            canvas.renderAll();
        }
    }
    useEffect(() => {
        renderSavedCanvasData(activeCanvas)
    }, [activeCanvas])

    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`, {
            height: 600,
            width: 600,
        })
        


        //  canvas.setBackgroundImage(activeCanvas ?.path, canvas.renderAll.bind(canvas), {
        //     // Needed to position backgroundImage at 0/0
        //     originX: 'left',
        //     originY: 'top'
        // });
        new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                scaleX: canvas.width / img.width,
                scaleY: canvas.height / img.height
            });
        })


        return canvas
    }
    useEffect(() => {
        setCanvas(initCanvas());
    }, []);

    useEffect(() => {
        if (canvas !== "") {
            canvas.on('object:modified', function (e) {
                const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {
                     if (shape.id === e.target.id) {
                        if (e.target.type === "Circle") {
                            return {
                                id: e.target.id,
                                type: "Circle",
                                radius: e.target.radius,
                                fill: e.target.fill,
                                left: e.target.left,
                                stroke: e.target.stroke,
                                strokeWidth: e.target.strokeWidth,
                                description: e.target.description,
                                navigateTo: e.target.navigateTo
                            }
                        } else if (e.target.type === "Rect") {
                            return {
                                id: e.target.id,
                                type: "Rect",
                                left: e.target.left,
                                top: e.target.top,
                                stroke: e.target.stroke,
                                strokeWidth: e.target.strokeWidth,
                                fill: e.target.fill,
                                width: e.target.width,
                                height: e.target.height,
                                description: e.target.description,
                                navigateTo: e.target.navigateTo
                            }
                        } else {
                            return {
                                id: e.target.id,
                                type: "node",
                                left: e.target.left,
                                top: e.target.top,
                                description: e.target.description,
                                navigateTo: e.target.navigateTo
                            }
                        }
                    } else {
                        return shape
                    }
                })
             setActiveCanvasData({
                    ...myStateRef.current,
                    shapes: updatedShapes
                })
                myStateRef.current = {
                    ...myStateRef.current,
                    shapes: updatedShapes
                }

            })
            // canvas.on('object:moving', function (e) {
            //     const updatedShapes = myStateRef ?.current ?.shapes ?.map(shape => {
            //         if (shape.id === e.target.id) {
            //             return {
            //                 ...e.target,
            //                 id:e.target.id
            //             }
            //         } else {
            //             return shape
            //         }
            //     })
            //  setActiveCanvasData({
            //     ...myStateRef.current,
            //     shapes: updatedShapes
            //     })
            //     myStateRef.current = {
            //         ...myStateRef.current,
            //         shapes: updatedShapes
            //     }
            // })
        }

    }, [canvas])

   

    // useEffect(() => {
    //     if (canvas !== "") { 
    //         activeCanvasData.shapes.forEach((shape, index) => {
    //             if (shape.type === "Circle") {
    //                 var circle = new fabric.Circle(shape);
    //                 // circle.on('modified', function (e) {
     //                 // });
    //                 canvas.add(circle);
    //             } else if (shape.type === "Rect") {
    //                 var rect = new fabric.Rect(shape);
    //                 canvas.add(rect);
    //             } else {
    //                 var node = new fabric.Circle({
    //                     radius: 20,
    //                     fill: 'rgba(0,0,0,0)',
    //                     left: 0,
    //                     stroke: "red",
    //                     top: 30,
    //                     strokeWidth: 4,
    //                 });
    //                 var nodeChild = new fabric.Circle({
    //                     radius: 10,
    //                     fill: 'rgba(0,0,0,0)',
    //                     left: 12,
    //                     fill: "red",
    //                     top: 42,
    //                 });
    //                 var group = new fabric.Group([node, nodeChild], shape)
    //                 canvas.add(group);
    //             }
    //         })

    //         canvas.renderAll();
    //     }
    // }, [activeCanvasData]);

    const addShapeHandler = (shape, index) => {
        // canvas.remove(...canvas.getObjects());
        // canvas.renderAll();description

        if (shape.shapeType === "Circle") {
            const circle = {
                type: "Circle",
                radius: 50,
                fill: 'rgba(0,0,0,0)',
                left: 0,
                stroke: "red",
                strokeWidth: 2,
                id: uuidv4(),
                description: "",
                navigateTo: ""
            }
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, circle]

            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, circle]
            }
            var circleShape = new fabric.Circle(circle);
            canvas.add(circleShape);
        } else if (shape.shapeType === "Rect") {
            const reactShape = {
                type: "Rect",
                left: 0,
                top: 0,
                stroke: 'red',
                strokeWidth: 2,
                fill: "transparent",
                width: 100,
                height: 100,
                id: uuidv4(),
                description: "",
                navigateTo: ""

            }
            var rect = new fabric.Rect(reactShape);
            canvas.add(rect)
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, reactShape]
            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, reactShape]
            }

        } else {
            var node = new fabric.Circle({
                radius: 20,
                fill: 'rgba(0,0,0,0)',
                left: 0,
                stroke: "red",
                top: 30,
                strokeWidth: 4,
            });
            var nodeChild = new fabric.Circle({
                radius: 10,
                fill: 'rgba(0,0,0,0)',
                left: 12,
                fill: "red",
                top: 42,
            });
            var group = new fabric.Group([node, nodeChild], {
                type: "node",
                left: 150,
                top: 100,
                id: uuidv4(),
                description: "",
                navigateTo: ""
            })
            canvas.add(group);
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, group]
            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, group]
            }
        }
        canvas.renderAll();

        setSelectedShape(null)

    }
    useEffect(() => {
        updateModeData(activeCanvasData)
    }, [activeCanvasData])
    return (
        <Row >
            <Col md={12} >
                <canvas id={`canvas`} width="1000" height="500" style={{ objectFit: "cover" }}></canvas>
            </Col>
            <Row className="mt-4">
                <Col md={6}>
                    <Select
                       
                        options={shapes}
                        placeholder='Select'
                        onChange={data => setSelectedShape(data)}
                        // value={selectedShape}
                    />
                </Col>
                <Col md={6}>
                    {selectedShape ?.label ?.length && <button className="btn btn-success w-100 " type={"button"} onClick={() => {
                        const shape = {
                            shapeType: selectedShape.label,
                        }
                        addShapeHandler(shape)
                    }}>Add</button>}
                </Col>
            </Row>
            <Row className="mt-4">
                     {activeCanvasData ?.shapes ?.map((ParentItem, itemIndex) => {
                        return (
                            <Row key={itemIndex}>
                                <Col md={3} className=" mt-3">
                                    <p className="font-size-16 mt-4">{ParentItem.type}</p>
                                </Col>
                                <Col md={3}>
                                    <AvForm>
                                        <AvField
                                            className="mb-3"
                                            name={`description${itemIndex}`}
                                            label={`description`}
                                            bsSize="lg"
                                            onChange={(e) => {
                                                const value = e.target.value
                                                  const updatedData = activeCanvasData.shapes.map((item, index) => {
                                                    if (itemIndex === index) {
                                                        return {
                                                            ...item,
                                                            description: value
                                                        }
                                                    } else {
                                                        return item
                                                    }
                                                })
                                                 setActiveCanvasData({
                                                    ...activeCanvasData,
                                                    shapes: [...updatedData]
                                                })

                                                // setActiveCanvasData([...updatedData])
                                            }}
                                            value={ParentItem ?.description}
                                        />
                                    </AvForm>

                                </Col>
                                <Col md={3}>
                                    <AvForm>
                                        <AvField
                                            className="mb-3"
                                            name={`navigateTo${itemIndex}`}
                                            label={`Navigate To Img Id`}
                                            bsSize="lg"
                                            onChange={(e) => {
                                                const value = e.target.value
                                                  const updatedData = activeCanvasData.shapes.map((item, index) => {
                                                    if (itemIndex === index) {
                                                        return {
                                                            ...item,
                                                            navigateTo: value
                                                        }
                                                    } else {
                                                        return item
                                                    }
                                                })
                                                 setActiveCanvasData({
                                                    ...activeCanvasData,
                                                    shapes: [...updatedData]
                                                })

                                                // setActiveCanvasData([...updatedData])
                                            }}
                                            value={ParentItem ?.navigateTo}
                                        />
                                    </AvForm>

                                </Col>
                            </Row>
                        )
                    })}
             </Row>
        </Row>
    )
}
export default CanvasFabric

/*
import React, { useEffect, useState ,useRef } from "react";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col
} from "reactstrap";
import { fabric } from "fabric";
import { v4 as uuidv4 } from 'uuid';

const shapes = [
    { value: 'Circle', label: 'Circle' },
    { value: 'Rect', label: 'Rect' },
    { value: 'node', label: 'node' }
]
const AddMode = (props) => {
     const [canvas, setCanvas] = useState('');
    const [activeCanvasData, setActiveCanvasData] = useState({
        compound:null,
        id: "",
        path: "",
        shapes: []
    })
    const myStateRef = useRef(activeCanvasData)

    useEffect(() => {
        const data = localStorage.getItem("materPhoto")
        const parsedData = JSON.parse(data)
        setActiveCanvasData({
            ...activeCanvasData,
            compound:parsedData.compound,
            id: parsedData.image.id,
            path: parsedData.image.path,
        })
 
    }, [])


    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`, {
            height: 400,
            width: 600,
        })
        new fabric.Image.fromURL(activeCanvasData ?.image ?.path, function (img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                scaleX: canvas.width / img.width,
                scaleY: canvas.height / img.height
            });
        })


        return canvas
    }
    useEffect(() => {
        setCanvas(initCanvas());
    }, [activeCanvasData]);


    const addShapeHandler = (shape) => {
        if (shape.shapeType === "Circle") {
            const circle = {
                type: "Circle",
                radius: 50,
                fill: 'rgba(0,0,0,0)',
                left: 0,
                stroke: "red",
                strokeWidth: 2,
                id: uuidv4(),
                description: "",
                navigateTo: ""
            }
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, circle]

            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, circle]
            }
            var circleShape = new fabric.Circle(circle);
            canvas.add(circleShape);
        } else if (shape.shapeType === "Rect") {
            const reactShape = {
                type: "Rect",
                left: 0,
                top: 0,
                stroke: 'red',
                strokeWidth: 2,
                fill: "transparent",
                width: 100,
                height: 100,
                id: uuidv4(),
                description: "",
                navigateTo: ""

            }
            var rect = new fabric.Rect(reactShape);
            canvas.add(rect)
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, reactShape]
            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, reactShape]
            }

        } else {
            var node = new fabric.Circle({
                radius: 20,
                fill: 'rgba(0,0,0,0)',
                left: 0,
                stroke: "red",
                top: 30,
                strokeWidth: 4,
            });
            var nodeChild = new fabric.Circle({
                radius: 10,
                fill: 'rgba(0,0,0,0)',
                left: 12,
                fill: "red",
                top: 42,
            });
            var group = new fabric.Group([node, nodeChild], {
                type: "node",
                left: 150,
                top: 100,
                id: uuidv4(),
                description: "",
                navigateTo: ""
            })
            canvas.add(group);
            setActiveCanvasData({
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, group]
            })
            myStateRef.current = {
                ...activeCanvasData,
                shapes: [...activeCanvasData.shapes, group]
            }
        }
        canvas.renderAll();

 
    }
    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>mode interactive</title>
                </MetaTags>
                <Container fluid>
                    <Row style={{height:"400px"}}>
                        <Col md={2}  className="d-flex justify-content-center  " style={{
                                //   backgroundImage: `url(${activeCanvasData?.image?.path})`,
                                // backgroundPosition: "center",
                                // backgroundRepeat: "no-repeat",
                                // backgroundSize: "cover",
                                // height: "100%",
                                //  backdropFilter: "blur(2px)"
                                background:"#a6a8a2"

                        }}>
                        <button style={{top:0,left:0,width:"20px",height:"20px",background:"none",border:"none",outline:"none",marginTop:"165px"}}>
                        <i className="fas fa-arrow-left fa-2x slider-icon "  ></i></button>
                        </Col>
                        <Col md={8} style={{zIndex:2}}>
                            <canvas id={`canvas`} style={{ objectFit: "cover" }}></canvas>
                        </Col>
                        <Col md={2}  className="d-flex justify-content-center "  style={{
                                //   backgroundImage: `url(${activeCanvasData?.image?.path})`,
                                // backgroundPosition: "center",
                                // backgroundRepeat: "no-repeat",
                                // backgroundSize: "cover",
                                // height: "100%",
                                // backdropFilter: "blur(2px)"
                                background:"#a6a8a2"
                        }}>
                        <button  style={{ top:0,left:0, width:"20px",height:"20px",background:"none",border:"none",outline:"none",marginTop:"165px"}}>
                        <i className="fas fa-arrow-right fa-2x slider-icon" ></i>
                        </button>
                        </Col>
                    </Row>
                    <Row className="mt-4 ">
                       <Col md={6} className="mt-4 "  >
                       <h5>No Hotspot Available</h5>
                        <h5>Please Add New Hotspot and start</h5>
                        <button className="btn btn-success" onClick={addShapeHandler}>Add New Hotspot </button>
                       </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default AddMode
*/